import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/AdSenseAd.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/Notification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-list/ProductListMobile.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-list/ShowMoreLayout.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-page/OfferTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-page/OfferTableMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-page/PriceTrend.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/products/ProductReview.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/SpecTable.jsx");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/apps/web/src/components/Typography.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/Star.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/StarBorder.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/StarHalf.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Stack/index.js");
